import { TextField } from '@mui/material'
import PropTypes from 'prop-types'

const FieldTextComponent = ({ value, config={}, events={} }) => {
    const handleChange = (e) => {
        if (events.handleChange)
            events.handleChange(e.target.value)
    }

    const error = config.errors?.[config.name]

    return (
        <TextField
            className="c-FieldText"
            label={config.label}
            placeholder={config.placeholder}
            type={config.type || 'text'}
            multiline={config.multiline}
            rows={config.rows}
            fullWidth
            size={config.size || 'small'}
            value={value ?? ''}
            onChange={handleChange}
            error={!!error}
            helperText={(error && error[0]) || config.helperText}
            InputProps={{
                startAdornment: config.startAdornment,
                endAdornment: config.endAdornment
            }}
            inputProps={config.label ? undefined : { 'aria-label': config.ariaLabel || config.placeholder }}
        />
    )
}

FieldTextComponent.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    config: PropTypes.shape({
        name: PropTypes.string,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        ariaLabel: PropTypes.string,
        type: PropTypes.string,
        multiline: PropTypes.bool,
        rows: PropTypes.number,
        helperText: PropTypes.string,
        errors: PropTypes.object,
        size: PropTypes.oneOf(['small', 'medium']),
        startAdornment: PropTypes.node,
        endAdornment: PropTypes.node
    }),

    events: PropTypes.shape({
        handleChange: PropTypes.func
    })
}

export { FieldTextComponent }
